import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import LandingNavbar from "./LandingNavbar";
import PageTransition from "../ui/PageTransition";
import Footer from "../Footer";

interface LandingLayoutProps {
  children: React.ReactNode;
}

const LandingLayout: React.FC<LandingLayoutProps> = ({ children }) => {
  const { t } = useTranslation("common");

  return (
    <div className="min-h-screen flex flex-col bg-space text-gray-100 font-sans">
      <Helmet>
        <title>港微創 HK MicroLaunch | AI 港式自動化行銷</title>
        <meta
          name="description"
          content={
            t("meta.description") ||
            "港微創 HK MicroLaunch — AI 驅動的港式 Marketing 自動化平台"
          }
        />
        <html lang="zh-HK" />
      </Helmet>

      <LandingNavbar />

      <main className="flex-grow">
        <PageTransition>{children}</PageTransition>
      </main>

      <Footer />
    </div>
  );
};

export default LandingLayout;
